module.exports = __webpack_public_path__ + "img/3.f517b1ae.jpg";